import { inject, Injectable } from '@angular/core';

import { ToolTitleRegistry } from '@core/tellent-assistant-data';

@Injectable({ providedIn: 'root' })
export class ToolTitlesFacade {
  private readonly registry = inject(ToolTitleRegistry);

  public readonly titles = this.registry.titlesSignal;

  public ensureLoaded(): Promise<void> {
    return this.registry.ensureLoaded();
  }
}
